import React from 'react'
import { Box, Typography } from '@material-ui/core'

import useJourneyWhiteLabel from 'hooks/useJourneyWhiteLabel'

import useStyles from './styles'

const HeaderTitle = () => {
  const styles = useStyles()
  const { currentStep, steps } = useJourneyWhiteLabel()

  const { title, subtitle } = steps[currentStep] || {}

  return (
    <Box
      mb={2}
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      gap={8}
    >
      <Typography variant="h1" gutterBottom>
        {title}
      </Typography>
      <Typography
        variant="subtitle1"
        component="h5"
        className={styles.typographySubtitle}
      >
        {subtitle}
      </Typography>
    </Box>
  )
}
export default HeaderTitle
